import { Link2 } from 'lucide-react';
import { IntegrationConnectCard } from '@/components/integration-connect-card';
import {
  CARBON_ARC_PROVIDER,
  CONNECT_PROVIDER_LABELS,
} from '@/utils/oauth-connect-signal';

// The one place the Carbon Arc card's identity lives. The chat renders it from
// a markdown link and the canvas from a connection check, and a label or icon
// that differed between the two would look like two integrations.
export const CarbonArcConnectCard = () => (
  <IntegrationConnectCard
    label={`Connect ${CONNECT_PROVIDER_LABELS[CARBON_ARC_PROVIDER]}`}
    // Placeholder: Carbon Arc ships no brand icon yet.
    icon={Link2}
    provider={CARBON_ARC_PROVIDER}
  />
);
